import { pick } from 'underscore';
export const DEFAULT_FILTER_KEY = 'default';
export const INTERSECTING_FILTERS = {
  BUSINESS_UNIT: 'businessUnitId'
};
export const EXCLUSIVE_FILTERS = {
  CAMPAIGN: 'hCampaign',
  EMAIL_TYPE: 'hEmailType',
  SUBSCRIPTIONS: 'hSubscriptions'
};
export const SUBSCRIPTION_CLASSIFICATION_TYPES = {
  ALL_MARKETING: 'ALL_MARKETING',
  ALL_TRANSACTIONAL: 'ALL_TRANSACTIONAL',
  ALL_MARKETING_AND_TRANSACTIONAL: 'ALL_MARKETING_AND_TRANSACTIONAL'
};

// If changing these values, keep in mind they are duplicated in ContentEmailUI/api/health.js
export const FILTERS = Object.assign({}, INTERSECTING_FILTERS, EXCLUSIVE_FILTERS);
export const DEFAULT_FILTER_PARAMS = {
  [FILTERS.BUSINESS_UNIT]: undefined,
  [FILTERS.CAMPAIGN]: undefined,
  [FILTERS.EMAIL_TYPE]: undefined,
  [FILTERS.SUBSCRIPTIONS]: undefined
};
export const CLEARED_EXCLUSIVE_FILTERS = pick(DEFAULT_FILTER_PARAMS, Object.values(EXCLUSIVE_FILTERS));
export const EMAIL_TYPES = {
  AB: 'AB',
  AUTOMATED: 'AUTOMATED',
  BLOG: 'BLOG',
  DOUBLE_OPT_IN: 'DOUBLE_OPT_IN',
  FEEDBACK: 'FEEDBACK',
  FOLLOWUP: 'FOLLOWUP',
  INTERNAL_NOTIFICATION: 'INTERNAL_NOTIFICATION',
  REGULAR: 'REGULAR',
  RESUBSCRIPTION_EMAILS: 'RESUBSCRIPTION_EMAILS',
  RSS: 'RSS',
  SMTP_API: 'SMTP_API',
  SINGLE_SEND_API: 'SINGLE_SEND_API',
  TICKET: 'TICKET',
  TIME_ZONE: 'TIME_ZONE',
  AUTOMATED_AB: 'AUTOMATED_AB'
};
export const MULTI_SELECT_FILTERS = [FILTERS.CAMPAIGN, FILTERS.SUBSCRIPTIONS];